/* (c) hop.t@turing.com
We want to steer away from redux to use React hooks
But it need some new implementation, because saga/logic/thunk won't works anymore :)
Ofcourse, we wouldn't want to re-write the whole saga/thunk things, just some simple case benefit to our app
*/

/* eslint-disable */
import React, { createContext, useContext } from 'react';
import createPersistedReducer from 'use-persisted-reducer';
import { useMiddleware } from './middleware';

/* USE DIFFERENT CONTEXT AND PROVIDER FOR ADMIN AND PUBLIC ROUTE, FOR NOT HAVING TO COMBINE ADMIN REDUCERS AND PUBLIC REDUCERS */
const initialState = {};
const DuckContext = createContext(initialState);

const DuckProvider = ({ children, history, reducer, reducerRoot }) => {
  const usePersistedReducer = createPersistedReducer(reducerRoot);
  const [state, dispatch] = usePersistedReducer(reducer, initialState);
  const enhanceDispatch = useMiddleware(dispatch);

  return React.createElement(DuckContext.Provider, { value: { state, enhanceDispatch, history } }, children);
  //return (<DuckContext.Provider value={{ state, enhanceDispatch }}> {children} </DuckContext.Provider>);
};

const connect = (mapStateToProps) => {
  return function (Component) {
    return function (_props) {
      const { enhanceDispatch, state, history } = useContext(DuckContext);
      const stateToProps = mapStateToProps ? mapStateToProps(state, _props) : state;
      const extraProps = { dispatch: enhanceDispatch, history: _props.history };

      return React.createElement(Component, { ..._props, ...stateToProps, ...extraProps });
      //return (<Component { ..._props } { ...stateToProps } { ...dispatchToProps } />);
    };
  };
};

export { connect, DuckContext, DuckProvider };
